import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Chatbot from './components/Chatbot';
import contentService from './services/contentService';
import './App.css';

function App() {
  // Get mode from URL params or environment
  const urlParams = new URLSearchParams(window.location.search);
  const mode = urlParams.get('mode') as 'standalone' | 'widget' || 'standalone';
  
 

  // These would typically come from environment variables or props
  const config = {
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  };

  return (
    <Router>
      <div className="App">
        <Switch>
          <Route 
            path="/" 
            render={() => (
              <Chatbot
                mode={mode}
                apiBaseUrl={config.apiBaseUrl}
                enableMockMode={false}
                placeholder={contentService.ui.placeholders.messageInput()}
                welcomeMessage={contentService.messages.welcomeStandalone()}
                maxMessages={50}
                theme="light"
              />
            )}
          />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
